import { define } from 'wicked-elements'
import ScrollBooster from 'scrollbooster'

function linmap (a1, b1, a2, b2, v) {
  return (v - a1) / (b1 - a1) * (b2 - a2) + a2
}

define('[data-component~="panorama"]', {
  init () {
    this.$pano = this.element.querySelector('[data-panorama]')
    this.$img = this.$pano.querySelector('img')
    this.$map = this.element.querySelector('[data-map]')
    this.$measure = this.element.querySelector('[data-measure]')
    this.booster = new ScrollBooster({
      viewport: this.$pano,
      scrollMode: 'native'
    })
  },
  connected () {
    this.$map.onclick = e => {
      const mapRect = this.$map.getBoundingClientRect()
      const xpos = e.clientX - mapRect.x
      const relativeX = (xpos * this.$img.clientWidth) / mapRect.width
      const shiftedToCenter = relativeX - (window.innerWidth / 2)
      this.booster.scrollTo({
        x: shiftedToCenter,
        y: 0
      })
      // this.$pano.scrollTo({
      //   top: 0,
      //   left: shiftedToCenter,
      //   behavior: 'smooth'
      // })
    }

    this.$pano.onscroll = e => {
      const mapRect = this.$map.getBoundingClientRect()
      const scrollState = this.booster.getState()
      const xpos = scrollState?.position?.x
      const halfwindow = window.innerWidth / 2
      const mapx = linmap(0, this.$img.clientWidth, 0, mapRect.width, xpos + halfwindow)
      this.$measure.style.left = mapx + 'px'
    }
  }
})